import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './cssModules/index.module.css';

export default function Unauthorized() {
    const navigate = useNavigate();
    const [seconds, setSeconds] = useState(5);

    useEffect(() => {
        if (seconds === 0) {
            navigate('/');
            return;
        }
        const timer = setTimeout(() => setSeconds(s => s - 1), 1000);
        return () => clearTimeout(timer);
    }, [seconds, navigate]);

    return (
        <div className={`${styles.errorDiv}`}>
            <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5'
                style={{ width: '72px', height: '72px', color: 'var(--status-error)' }}>
                <path strokeLinecap='round' strokeLinejoin='round'
                    d='M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z' />
            </svg>
            <span style={{ fontSize: '22px', fontWeight: '700', letterSpacing: '1px', color: 'var(--text-primary)' }}>
                NOT AUTHORIZED
            </span>
            <span style={{ fontSize: '14px', color: 'var(--text-secondary)', textAlign: 'center', maxWidth: '340px', lineHeight: '1.6' }}>
                Designers are not authorized to view this page.
            </span>
            <div style={{
                width: '64px', height: '64px', borderRadius: '50%',
                border: '3px solid var(--brand-primary)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '26px', fontWeight: '700', color: 'var(--brand-primary)'
            }}>
                {seconds}
            </div>
            <span style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
                Redirecting to home in {seconds} second{seconds !== 1 ? 's' : ''}...
            </span>
            <button
                onClick={() => navigate('/')}
                style={{
                    marginTop: '8px', padding: '10px 28px',
                    background: 'var(--brand-primary)', color: '#fff',
                    border: 'none', borderRadius: 'var(--radius-pill)',
                    fontSize: '13px', fontWeight: '600', letterSpacing: '1px',
                    cursor: 'pointer'
                }}>
                GO TO HOME
            </button>
        </div>
    );
}
